var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-mod-container"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"text"},[_vm._v("您尚未购买指定课程")])])])}]

export { render, staticRenderFns }